var map = {
	"./1.jpg": 748,
	"./2.jpg": 338,
	"./3.jpg": 3274,
	"./4.jpg": 7227,
	"./5.jpg": 8970,
	"./6.jpg": 7557,
	"./7.jpg": 7844,
	"./8.jpg": 4299,
	"./9.jpg": 8303
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6825;